<template>
  <transition name="loader">
    <div class="loader" v-if="loading">
      <svg class="loader__filter" version="1.1">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"
            />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -10"
              result="goo" />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
      <div class="loader__dots">
        <div class="loader__dot loader__dot--1 mainDot"></div>
        <div class="loader__dot loader__dot--2"></div>
        <div class="loader__dot loader__dot--3"></div>
        <div class="loader__dot loader__dot--4"></div>
        <div class="loader__dot loader__dot--5"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppLoader',
  computed: {
    ...mapGetters(['loading'])
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/partials/AppLoader.vue